import CourseService from '../../../services/courses.service';
import ProviderService from '../../../services/providers.service';
import axios from 'axios'

var CancelToken = axios.CancelToken;
var Source = null;

export async function getCourses(store, { currentPage, pageSize, filters }) {
    try {
        const state = store.state;
        let newFilters = filters || state.CourseList.filters;
        pageSize = (!pageSize || pageSize <= 0) ? 1 : pageSize;
        store.setState({ CourseList: { ...state.CourseList, filters: newFilters, pagination: { ...state.CourseList.pagination, pageSize }, selectedCourses: [] } });

        if (Source) {
            Source.cancel();
        }
        Source = CancelToken.source();
        const { items, pagination } = await CourseService().getCourses(currentPage, pageSize, newFilters, Source.token);
        Source = null;
        store.setState({ CourseList: { ...store.state.CourseList, items, pagination, filters: newFilters }, selectedCourses: [] });
    }
    catch (error) {
        if (axios.isCancel(error)) {
            console.log('request cancelled');
        }
        else {
            throw error;
        }
    }
}

export function setSelectPage(store, newSelectedValue) {
    const coursesToOperate = [...store.state.CourseList.items.map(course => course.id)];
    let newSelectedCourses = store.state.CourseList.selectedCourses;
    coursesToOperate.forEach(element => newSelectedCourses = getNewSelectedArray(newSelectedCourses, element, newSelectedValue));
    store.setState({ CourseList: { ...store.state.CourseList, selectedCourses: newSelectedCourses } })
}

export function setSelect(store, { courseId, newSelectedValue }) {
    const newSelectedCourses = getNewSelectedArray(store.state.CourseList.selectedCourses, courseId, newSelectedValue);
    store.setState({ CourseList: { ...store.state.CourseList, selectedCourses: newSelectedCourses } })
}

export function setSelectAll(store, allSelected) {
    store.setState({ CourseList: { ...store.state.CourseList, allSelected } });
}

function getNewSelectedArray(initialArray, id, newSelectedValue) {
    return newSelectedValue ?
        (initialArray.indexOf(id) !== -1 ? initialArray : [...initialArray, id]) :
        (initialArray.filter(currentId => currentId !== id))
}

export async function enableCourses(store, all) {
    if (all)
        await CourseService().enableCoursesBulk(store.state.CourseList.filters);
    else
        await CourseService().enableCourses(store.state.CourseList.selectedCourses);
}

export async function disableCourses(store, all) {
    if (all)
        await CourseService().disableCoursesBulk(store.state.CourseList.filters);
    else
        await CourseService().disableCourses(store.state.CourseList.selectedCourses);
}

export async function getProviders(store) {
    const providers = await ProviderService().getAllProviders();
    store.setState({ CourseList: { ...store.state.CourseList, providers } })
}

export async function refreshCourse(store,{courseId})
{
    const refresed = await CourseService().refreshCourse(courseId);                                                  
}